import type { UserFeatures } from '../models/UserFeatures.d.ts';

export function hasAiResponsesLimit(userFeatures: UserFeatures): boolean {
  return userFeatures.ai_responses > 0 || userFeatures.extra_ai_responses > 0;
}
